import {
  explainRoomSearchFailure as explainBelvedereRoomSearchFailure,
  getCompatibleRoomOffers as getBelvedereCompatibleRoomOffers,
  getStayNights,
  isBelvedereAgentPricingChannel,
  normalizeBelvedereCampaignRoomOccupancy,
  toSelectedRoom,
  validateStayDates as validateBelvedereStayDates,
} from "./belvederePricing";
import { royalTulipTbilisiContract } from "../data/royalTulipTbilisiContractData";

export const ROYAL_TULIP_INFANT_MAX_AGE = 2.99;
export const ROYAL_TULIP_CHILD_MAX_AGE = 11.99;

export function normalizeRoyalTulipOccupancy(room) {
  const base = normalizeBelvedereCampaignRoomOccupancy(room);
  const infantAges = [];
  const kidAges = [];
  const olderAsAdults = [];
  for (const age of base.childAges) {
    if (age >= 0 && age <= ROYAL_TULIP_INFANT_MAX_AGE) infantAges.push(age);
    else if (age > ROYAL_TULIP_INFANT_MAX_AGE && age <= ROYAL_TULIP_CHILD_MAX_AGE) kidAges.push(age);
    else olderAsAdults.push(age);
  }
  return {
    adults: base.adults + olderAsAdults.length,
    children: kidAges.length,
    childAges: kidAges,
    infants: infantAges.length,
  };
}

export function normalizeRoyalTulipRooms(rooms) {
  const list = Array.isArray(rooms) ? rooms : [];
  return list.slice(0, 6).map((room) => {
    const normalized = normalizeRoyalTulipOccupancy(room);
    return {
      adults: normalized.adults,
      children: normalized.children,
      childAges: normalized.childAges,
    };
  });
}

export function validateRoyalTulipStayDates(arrivalDate, departureDate) {
  return validateBelvedereStayDates(arrivalDate, departureDate, royalTulipTbilisiContract);
}

export function getCompatibleRoyalTulipRoomOffers(
  occupancies,
  arrivalDate,
  departureDate,
  contractOrOptions = {},
  maybePricingOptions = {},
) {
  const looksLikeContract = Boolean(
    contractOrOptions &&
      (contractOrOptions.roomTypes ||
        contractOrOptions.hotelCode ||
        contractOrOptions.agentMarkupPercent != null ||
        contractOrOptions.publicEffectiveMarkupTargetPercent != null),
  );
  const contract = looksLikeContract
    ? { ...royalTulipTbilisiContract, ...contractOrOptions }
    : royalTulipTbilisiContract;
  const pricingOptions = looksLikeContract ? maybePricingOptions : contractOrOptions;
  return getBelvedereCompatibleRoomOffers(
    normalizeRoyalTulipRooms(occupancies),
    arrivalDate,
    departureDate,
    contract,
    pricingOptions,
  );
}

export function explainRoyalTulipRoomSearchFailure(
  occupancies,
  arrivalDate,
  departureDate,
  contractOrUnused,
) {
  return explainBelvedereRoomSearchFailure(
    normalizeRoyalTulipRooms(occupancies),
    arrivalDate,
    departureDate,
    royalTulipTbilisiContract,
  );
}

export {
  getStayNights,
  isBelvedereAgentPricingChannel,
  toSelectedRoom,
};
